export default "__VITE_ASSET__BanN4hmE__"